import constants from '../constants'

/**
 * Default Values:
 *
 *  hideAddressLine2: false,
 *  showCityStateZipFirst: false,
 *  enableGoogleAutoComplete: false
 *  optionalAddress1: false
 *
 */
export const ADDRESS_CONFIG = {
    "JP": {
        "address1RegexValidation": constants.JP.regex.allowedCharacters,
        "hideAddressLine2": true,
        "showCityStateZipFirst": true,
        "optionalAddress1": true,
        "enableGoogleAutoComplete": true
    },
    "NC": {
        "hideAddressLine2": true
    },
    "NZ": {
        "hideAddressLine2": true
    },
    "PF": {
        "hideAddressLine2": true
    },
    "RU": {
        "hideAddressLine2": true
    },
    "UA": {
        "hideAddressLine2": true
    },
    "US": {
        "enableGoogleAutoComplete": true
    }
};
